import { render, staticRenderFns } from "./DetailsTiers.vue?vue&type=template&id=373ae49c&"
import script from "./DetailsTiers.vue?vue&type=script&lang=js&"
export * from "./DetailsTiers.vue?vue&type=script&lang=js&"
import style0 from "./DetailsTiers.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports